import React from 'react';
export function Footer() {
  return <footer className="bg-stone-900 text-stone-400 py-12 px-4 text-center text-sm" data-id="element-163">
      <div className="max-w-4xl mx-auto" data-id="element-164">
        <div className="mb-8" data-id="element-165">
          <p className="text-white font-bold text-lg mb-2" data-id="element-166">
            🇨🇷 RECONECTA CONTIGO HOY™
          </p>
          <p className="mb-1" data-id="element-167">
            El sistema de bienestar y herramientas N°1 para docentes del MEP en
            Costa Rica.
          </p>
          <p data-id="element-168">
            Porque enseñar en el MEP no debería costarte todos los domingos del
            año.
          </p>
        </div>

        <div className="flex flex-col md:flex-row justify-center items-center gap-4 md:gap-8 mb-8" data-id="element-169">
          <a href="mailto:reconectacontigohoy506@gmail.com" className="hover:text-white transition-colors" data-id="element-170">
            📧 reconectacontigohoy506@gmail.com
          </a>
          <a href="https://www.reconectacontigohoy.com" className="hover:text-white transition-colors" data-id="element-171">
            🌐 www.reconectacontigohoy.com
          </a>
        </div>

        <div className="border-t border-stone-800 pt-8" data-id="element-172">
          <p className="mb-4" data-id="element-173">
            © Reconecta Contigo Hoy™ 2026 — Todos los derechos reservados.
            Prohibida la reproducción y redistribución sin autorización expresa.
          </p>
          <p className="text-brand-500 font-medium italic" data-id="element-174">
            "El próximo domingo puede ser tuyo." 🇨🇷
          </p>
        </div>
      </div>
    </footer>;
}